// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2EFvW","input":"styles_input__1yhru"};